<template>
  <v-container
    id="dashboard"
    tag="section"
    class="my-3 pb-15"
    fluid
  >
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card class="ma-0 pa-0" height="100%">
          <br>
          <div class="caption font-weight-light ml-2 mt-n2">
            IMOBILIZADO INCREMENTAL {{ ['light', 'light-e'].includes(empresa) ? '' : '(LTM)' }}
          </div>
          <imobilizado-acumulado-line
            class="mt-3"
          />
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ma-0 pa-0" height="100%">
          <br>
          <div class="caption font-weight-light ml-2 mt-n2">
            IMOBILIZADO ÚLTIMO MÊS - {{ultimoAIS}}
          </div>
          <imobilizado-ultimo-mes-tipologia-pie
            ref="imobpie"
          />
        </v-card>
      </v-col>
    </v-row>
    <div id="tawk-to-fab" class="location-fab-tawk" />
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js'
  import dayjs from 'dayjs'
  import 'dayjs/locale/pt'
  import tourMixins from '@/mixins/tourMixins';
  import drawerMixins from "@/mixins/drawerMixins"

  export default {
    name: 'Home',
    mixins: [drawerMixins, tourMixins],
    components: {
      ImobilizadoAcumuladoLine: () => import('@/components/general/graficos/ImobilizadoAcumuladoLine.vue'),
      ImobilizadoUltimoMesTipologiaPie: () => import('@/components/general/graficos/ImobilizadoUltimoMesTipologiaPie.vue'),
    },
    data () {
      return {
        dataUltimoAis: [],
      }
    },
    firestore() {
      return {
        dataUltimoAis: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Ultimo AIS'),
      }
    },
    mounted () {
      if (this.empresa) {
        const arrTour = [
          {
            title: 'Bem vindo ao HEXA',
            intro: `O seu sistema exclusivo de Gestão Estratégica de BRR.<br<br><br><br>
                    Este breve tutorial apresenta instruções básicas para navegação no sistema.<br><br>
                    Para desabilitá-lo basta fechar esta caixa de mensagem.<br> Caso queira acessar o tutorial posteriormente, clique no botão <b>(?)</b> no menu lateral.
                    `,
          },
          {
            element: '#core-navigation-drawer',
            title: 'Menu',
            intro: 'Este é o menu principal, nele estão as principais funcionalidades do <b>HEXA</b>.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-profile',
            title: 'Perfil',
            intro: 'Aqui você poderá editar seus dados pessoais (foto, nome e senha) e deslogar do sistema.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-mudar-empresa',
            title: 'Mudar de empresa',
            intro: 'Aqui você poderá se conectar ao sistema de outras empresas que você tem acesso.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-dashboard',
            title: 'Dashboard',
            intro: 'Esta é a tela inicial do <b>HEXA</b>, onde são apresentados os gráficos e principais informações de BRR da distribuidora.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-relatórios',
            title: 'Relatórios',
            intro: 'Aqui você poderá fazer consultas sobre as bases de dados ou usar relatórios modelo (predefinidos). Também é possível acessar tabelas regulatórias (MCPSE, índices de inflação, módulos BPR, etc).',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-powerups',
            title: 'Power Ups',
            intro: 'Aqui você acessa as ferramentas exclusivas de Gestão de BRR, Conformidade de Obras, Fiscalização da ANEEL, dentre outras.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-dados',
            title: 'Dados',
            intro: 'Aqui você poderá atualizar os dados do sistema através de arquivos CSV, cadastro de IPCA, dentre outros.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#drawer-section-tutorial',
            title: 'Tutorial',
            intro: 'Clicando nessa opção você poderá acessar o tutorial sempre que precisar.',
            scrollTo: "tooltip",
            position: 'right'
          },
          {
            element: '#tawk-to-fab',
            title: 'Chat',
            intro: 'Em caso de dúvidas, entre em contato com um dos nossos especialistas em tempo real através do nosso chat.',
            scrollTo: "tooltip",
            position: 'top'
          }
        ];
        this.iniciarTour(arrTour);
        this.changeSizeHeaderDashBoard();
      }
    },
    computed: {
      empresa() {
        return this.$store.getters.getEmpresa.toLowerCase();
      },
      ultimoAIS: function () {
        if(this.dataUltimoAis == null || this.dataUltimoAis.length == 0) return ""
        return dayjs(this.dataUltimoAis["0"]["MaxDataBaseAIS"]).locale('pt').format('MM/YYYY')
      },
    },
    methods: {
      initTour () {
        let elementBody = document.getElementsByTagName("html")[0];

        let onBeforeChangeFunction = (() => {
          /* ira fixar a tela simulando scroll desabilitado */
          elementBody.style.position = "fixed";
          elementBody.style.top = "0";
          elementBody.style.width = "100%";
        });

        let onBeforeExitFunction = (() => {
         /* ira retirar a fixação de tela retirando efeito da func onBeforeChange */
          elementBody.style.position = '';
          elementBody.style.top = '';
        });

        this.iniciarTour(this.arrTerceiraTabTour, [], [onBeforeChangeFunction], [onBeforeExitFunction]);
      }
    },
    watch: {
      '$vuetify.breakpoint.width' (val) {
        this.changeSizeHeaderDashBoard();
      },
    }
  }
</script>

<style scoped>
  .location-fab-tawk {
   position: fixed;
   bottom: 1.4rem;
   right: 19px;
   width: 61px;
   border-radius: 50%;
   padding: 30px;
  }
</style>
